/** The `palette` area: the command palette and the item search dialog. Owned by
 *  the stage 2 slot components-a (docs/I18N.md §11). */
export const palette = {
  // The global commands (`buildGlobalCommands`).
  'palette.command.goTo': 'Go to {page}',
  'palette.command.newItem': 'New item',
  'palette.command.newLens': 'New view',
  'palette.command.newView': 'New board',
  'palette.command.themeLight': 'Theme: Light',
  'palette.command.themeDark': 'Theme: Dark',
  'palette.command.themeSystem': 'Theme: System',
  // The kind badge on a place row.
  'palette.kind.page': 'page',
  'palette.kind.board': 'board',
  'palette.kind.view': 'map view',
  'palette.kind.lens': 'view',
  'palette.kind.group': 'group',
  'palette.kind.flow': 'flow',
  'palette.kind.plan': 'plan',
  'palette.kind.ceremony': 'ceremony',
  'palette.kind.person': 'person',
  'palette.kind.command': 'command',
  'palette.kind.narrowBy': 'narrow by…',
  'palette.kind.filter': 'filter',
  'palette.kind.item': 'item',
  // The panel.
  'palette.panel.command': 'Run a command',
  'palette.panel.open': 'Jump to',
  'palette.input.command': 'Type a command',
  'palette.input.open': 'Search items, or jump to a view or board (type > for commands)',
  'palette.input.commandPlaceholder': 'Run a command…',
  'palette.input.openPlaceholder': 'Search…',
  'palette.empty.command': 'No matching command.',
  'palette.empty.noMatches': 'No matches.',
  'palette.empty.hint': 'Type to search items and places.',
  'palette.row.seeAll': 'See all results',
  // The item search dialog.
  'palette.itemSearch.cancel': 'Cancel',
  'palette.itemSearch.placeholder': 'Search work…',
  'palette.itemSearch.results': 'Matching work',
  /** Extra match words per command, space-separated, matched with the label. */
  'palette.keywords.goTo': 'open jump',
  'palette.keywords.newItem': 'create task add',
  'palette.keywords.newLens': 'create view filter add',
  'palette.keywords.newView': 'create board kanban list checklist add',
  'palette.keywords.themeLight': 'appearance colors',
  'palette.keywords.themeDark': 'appearance colors night',
  'palette.keywords.themeSystem': 'appearance colors auto',
} as const;
